/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BulkFeatureRequestV1 } from '../models';
// @ts-ignore
import type { FeatureDataResponse } from '../models';
// @ts-ignore
import type { UpdateFeatureForTemplateRequest } from '../models';
/**
 * FeaturesApi - axios parameter creator
 * @export
 */
export const FeaturesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allFeaturesForCustomer: async (customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('allFeaturesForCustomer', 'customerId', customerId)
            const localVarPath = `/bo/v1/features/customers/{customerId}/features`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allFeaturesForTemplate: async (templateId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('allFeaturesForTemplate', 'templateId', templateId)
            const localVarPath = `/bo/v1/features/templates/{templateId}/features`
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} featureId 
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeatureForCustomer: async (featureId: string, customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'featureId' is not null or undefined
            assertParamExists('getFeatureForCustomer', 'featureId', featureId)
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getFeatureForCustomer', 'customerId', customerId)
            const localVarPath = `/bo/v1/features/{featureId}/customers/{customerId}`
                .replace(`{${"featureId"}}`, encodeURIComponent(String(featureId)))
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} featureId 
         * @param {string} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeatureForTemplate: async (featureId: string, templateId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'featureId' is not null or undefined
            assertParamExists('getFeatureForTemplate', 'featureId', featureId)
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('getFeatureForTemplate', 'templateId', templateId)
            const localVarPath = `/bo/v1/features/{featureId}/templates/{templateId}`
                .replace(`{${"featureId"}}`, encodeURIComponent(String(featureId)))
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} templateId 
         * @param {BulkFeatureRequestV1} bulkFeatureRequestV1 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceFeaturesForTemplate: async (templateId: string, bulkFeatureRequestV1: BulkFeatureRequestV1, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('replaceFeaturesForTemplate', 'templateId', templateId)
            // verify required parameter 'bulkFeatureRequestV1' is not null or undefined
            assertParamExists('replaceFeaturesForTemplate', 'bulkFeatureRequestV1', bulkFeatureRequestV1)
            const localVarPath = `/bo/v1/features/templates/{templateId}/features`
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkFeatureRequestV1, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} featureId 
         * @param {string} customerId 
         * @param {UpdateFeatureForTemplateRequest} updateFeatureForTemplateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFeatureForCustomer: async (featureId: string, customerId: string, updateFeatureForTemplateRequest: UpdateFeatureForTemplateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'featureId' is not null or undefined
            assertParamExists('setFeatureForCustomer', 'featureId', featureId)
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('setFeatureForCustomer', 'customerId', customerId)
            // verify required parameter 'updateFeatureForTemplateRequest' is not null or undefined
            assertParamExists('setFeatureForCustomer', 'updateFeatureForTemplateRequest', updateFeatureForTemplateRequest)
            const localVarPath = `/bo/v1/features/{featureId}/customers/{customerId}`
                .replace(`{${"featureId"}}`, encodeURIComponent(String(featureId)))
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFeatureForTemplateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} featureId 
         * @param {string} templateId 
         * @param {UpdateFeatureForTemplateRequest} updateFeatureForTemplateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFeatureForTemplate: async (featureId: string, templateId: string, updateFeatureForTemplateRequest: UpdateFeatureForTemplateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'featureId' is not null or undefined
            assertParamExists('setFeatureForTemplate', 'featureId', featureId)
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('setFeatureForTemplate', 'templateId', templateId)
            // verify required parameter 'updateFeatureForTemplateRequest' is not null or undefined
            assertParamExists('setFeatureForTemplate', 'updateFeatureForTemplateRequest', updateFeatureForTemplateRequest)
            const localVarPath = `/bo/v1/features/{featureId}/templates/{templateId}`
                .replace(`{${"featureId"}}`, encodeURIComponent(String(featureId)))
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFeatureForTemplateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} templateId 
         * @param {BulkFeatureRequestV1} bulkFeatureRequestV1 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFeaturesForTemplate: async (templateId: string, bulkFeatureRequestV1: BulkFeatureRequestV1, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('setFeaturesForTemplate', 'templateId', templateId)
            // verify required parameter 'bulkFeatureRequestV1' is not null or undefined
            assertParamExists('setFeaturesForTemplate', 'bulkFeatureRequestV1', bulkFeatureRequestV1)
            const localVarPath = `/bo/v1/features/templates/{templateId}/features`
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkFeatureRequestV1, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} featureId 
         * @param {string} customerId 
         * @param {UpdateFeatureForTemplateRequest} updateFeatureForTemplateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFeatureForCustomer: async (featureId: string, customerId: string, updateFeatureForTemplateRequest: UpdateFeatureForTemplateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'featureId' is not null or undefined
            assertParamExists('updateFeatureForCustomer', 'featureId', featureId)
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('updateFeatureForCustomer', 'customerId', customerId)
            // verify required parameter 'updateFeatureForTemplateRequest' is not null or undefined
            assertParamExists('updateFeatureForCustomer', 'updateFeatureForTemplateRequest', updateFeatureForTemplateRequest)
            const localVarPath = `/bo/v1/features/{featureId}/customers/{customerId}`
                .replace(`{${"featureId"}}`, encodeURIComponent(String(featureId)))
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFeatureForTemplateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} featureId 
         * @param {string} templateId 
         * @param {UpdateFeatureForTemplateRequest} updateFeatureForTemplateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFeatureForTemplate: async (featureId: string, templateId: string, updateFeatureForTemplateRequest: UpdateFeatureForTemplateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'featureId' is not null or undefined
            assertParamExists('updateFeatureForTemplate', 'featureId', featureId)
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('updateFeatureForTemplate', 'templateId', templateId)
            // verify required parameter 'updateFeatureForTemplateRequest' is not null or undefined
            assertParamExists('updateFeatureForTemplate', 'updateFeatureForTemplateRequest', updateFeatureForTemplateRequest)
            const localVarPath = `/bo/v1/features/{featureId}/templates/{templateId}`
                .replace(`{${"featureId"}}`, encodeURIComponent(String(featureId)))
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFeatureForTemplateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FeaturesApi - functional programming interface
 * @export
 */
export const FeaturesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FeaturesApiAxiosParamCreator(configuration)
    return {
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async allFeaturesForCustomer(customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FeatureDataResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.allFeaturesForCustomer(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeaturesApi.allFeaturesForCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async allFeaturesForTemplate(templateId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FeatureDataResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.allFeaturesForTemplate(templateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeaturesApi.allFeaturesForTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} featureId 
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFeatureForCustomer(featureId: string, customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeatureDataResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFeatureForCustomer(featureId, customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeaturesApi.getFeatureForCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} featureId 
         * @param {string} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFeatureForTemplate(featureId: string, templateId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeatureDataResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFeatureForTemplate(featureId, templateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeaturesApi.getFeatureForTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} templateId 
         * @param {BulkFeatureRequestV1} bulkFeatureRequestV1 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replaceFeaturesForTemplate(templateId: string, bulkFeatureRequestV1: BulkFeatureRequestV1, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replaceFeaturesForTemplate(templateId, bulkFeatureRequestV1, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeaturesApi.replaceFeaturesForTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} featureId 
         * @param {string} customerId 
         * @param {UpdateFeatureForTemplateRequest} updateFeatureForTemplateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setFeatureForCustomer(featureId: string, customerId: string, updateFeatureForTemplateRequest: UpdateFeatureForTemplateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setFeatureForCustomer(featureId, customerId, updateFeatureForTemplateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeaturesApi.setFeatureForCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} featureId 
         * @param {string} templateId 
         * @param {UpdateFeatureForTemplateRequest} updateFeatureForTemplateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setFeatureForTemplate(featureId: string, templateId: string, updateFeatureForTemplateRequest: UpdateFeatureForTemplateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setFeatureForTemplate(featureId, templateId, updateFeatureForTemplateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeaturesApi.setFeatureForTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} templateId 
         * @param {BulkFeatureRequestV1} bulkFeatureRequestV1 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setFeaturesForTemplate(templateId: string, bulkFeatureRequestV1: BulkFeatureRequestV1, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setFeaturesForTemplate(templateId, bulkFeatureRequestV1, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeaturesApi.setFeaturesForTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} featureId 
         * @param {string} customerId 
         * @param {UpdateFeatureForTemplateRequest} updateFeatureForTemplateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFeatureForCustomer(featureId: string, customerId: string, updateFeatureForTemplateRequest: UpdateFeatureForTemplateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeatureDataResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFeatureForCustomer(featureId, customerId, updateFeatureForTemplateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeaturesApi.updateFeatureForCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} featureId 
         * @param {string} templateId 
         * @param {UpdateFeatureForTemplateRequest} updateFeatureForTemplateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFeatureForTemplate(featureId: string, templateId: string, updateFeatureForTemplateRequest: UpdateFeatureForTemplateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeatureDataResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFeatureForTemplate(featureId, templateId, updateFeatureForTemplateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeaturesApi.updateFeatureForTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FeaturesApi - factory interface
 * @export
 */
export const FeaturesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FeaturesApiFp(configuration)
    return {
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allFeaturesForCustomer(customerId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<FeatureDataResponse>> {
            return localVarFp.allFeaturesForCustomer(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allFeaturesForTemplate(templateId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<FeatureDataResponse>> {
            return localVarFp.allFeaturesForTemplate(templateId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} featureId 
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeatureForCustomer(featureId: string, customerId: string, options?: RawAxiosRequestConfig): AxiosPromise<FeatureDataResponse> {
            return localVarFp.getFeatureForCustomer(featureId, customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} featureId 
         * @param {string} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeatureForTemplate(featureId: string, templateId: string, options?: RawAxiosRequestConfig): AxiosPromise<FeatureDataResponse> {
            return localVarFp.getFeatureForTemplate(featureId, templateId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} templateId 
         * @param {BulkFeatureRequestV1} bulkFeatureRequestV1 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceFeaturesForTemplate(templateId: string, bulkFeatureRequestV1: BulkFeatureRequestV1, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.replaceFeaturesForTemplate(templateId, bulkFeatureRequestV1, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} featureId 
         * @param {string} customerId 
         * @param {UpdateFeatureForTemplateRequest} updateFeatureForTemplateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFeatureForCustomer(featureId: string, customerId: string, updateFeatureForTemplateRequest: UpdateFeatureForTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setFeatureForCustomer(featureId, customerId, updateFeatureForTemplateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} featureId 
         * @param {string} templateId 
         * @param {UpdateFeatureForTemplateRequest} updateFeatureForTemplateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFeatureForTemplate(featureId: string, templateId: string, updateFeatureForTemplateRequest: UpdateFeatureForTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setFeatureForTemplate(featureId, templateId, updateFeatureForTemplateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} templateId 
         * @param {BulkFeatureRequestV1} bulkFeatureRequestV1 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFeaturesForTemplate(templateId: string, bulkFeatureRequestV1: BulkFeatureRequestV1, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setFeaturesForTemplate(templateId, bulkFeatureRequestV1, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} featureId 
         * @param {string} customerId 
         * @param {UpdateFeatureForTemplateRequest} updateFeatureForTemplateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFeatureForCustomer(featureId: string, customerId: string, updateFeatureForTemplateRequest: UpdateFeatureForTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<FeatureDataResponse> {
            return localVarFp.updateFeatureForCustomer(featureId, customerId, updateFeatureForTemplateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} featureId 
         * @param {string} templateId 
         * @param {UpdateFeatureForTemplateRequest} updateFeatureForTemplateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFeatureForTemplate(featureId: string, templateId: string, updateFeatureForTemplateRequest: UpdateFeatureForTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<FeatureDataResponse> {
            return localVarFp.updateFeatureForTemplate(featureId, templateId, updateFeatureForTemplateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FeaturesApi - object-oriented interface
 * @export
 * @class FeaturesApi
 * @extends {BaseAPI}
 */
export class FeaturesApi extends BaseAPI {
    /**
     * hasBackOfficeFullRole()
     * @param {string} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturesApi
     */
    public allFeaturesForCustomer(customerId: string, options?: RawAxiosRequestConfig) {
        return FeaturesApiFp(this.configuration).allFeaturesForCustomer(customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} templateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturesApi
     */
    public allFeaturesForTemplate(templateId: string, options?: RawAxiosRequestConfig) {
        return FeaturesApiFp(this.configuration).allFeaturesForTemplate(templateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} featureId 
     * @param {string} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturesApi
     */
    public getFeatureForCustomer(featureId: string, customerId: string, options?: RawAxiosRequestConfig) {
        return FeaturesApiFp(this.configuration).getFeatureForCustomer(featureId, customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} featureId 
     * @param {string} templateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturesApi
     */
    public getFeatureForTemplate(featureId: string, templateId: string, options?: RawAxiosRequestConfig) {
        return FeaturesApiFp(this.configuration).getFeatureForTemplate(featureId, templateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} templateId 
     * @param {BulkFeatureRequestV1} bulkFeatureRequestV1 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturesApi
     */
    public replaceFeaturesForTemplate(templateId: string, bulkFeatureRequestV1: BulkFeatureRequestV1, options?: RawAxiosRequestConfig) {
        return FeaturesApiFp(this.configuration).replaceFeaturesForTemplate(templateId, bulkFeatureRequestV1, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} featureId 
     * @param {string} customerId 
     * @param {UpdateFeatureForTemplateRequest} updateFeatureForTemplateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturesApi
     */
    public setFeatureForCustomer(featureId: string, customerId: string, updateFeatureForTemplateRequest: UpdateFeatureForTemplateRequest, options?: RawAxiosRequestConfig) {
        return FeaturesApiFp(this.configuration).setFeatureForCustomer(featureId, customerId, updateFeatureForTemplateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} featureId 
     * @param {string} templateId 
     * @param {UpdateFeatureForTemplateRequest} updateFeatureForTemplateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturesApi
     */
    public setFeatureForTemplate(featureId: string, templateId: string, updateFeatureForTemplateRequest: UpdateFeatureForTemplateRequest, options?: RawAxiosRequestConfig) {
        return FeaturesApiFp(this.configuration).setFeatureForTemplate(featureId, templateId, updateFeatureForTemplateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} templateId 
     * @param {BulkFeatureRequestV1} bulkFeatureRequestV1 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturesApi
     */
    public setFeaturesForTemplate(templateId: string, bulkFeatureRequestV1: BulkFeatureRequestV1, options?: RawAxiosRequestConfig) {
        return FeaturesApiFp(this.configuration).setFeaturesForTemplate(templateId, bulkFeatureRequestV1, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} featureId 
     * @param {string} customerId 
     * @param {UpdateFeatureForTemplateRequest} updateFeatureForTemplateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturesApi
     */
    public updateFeatureForCustomer(featureId: string, customerId: string, updateFeatureForTemplateRequest: UpdateFeatureForTemplateRequest, options?: RawAxiosRequestConfig) {
        return FeaturesApiFp(this.configuration).updateFeatureForCustomer(featureId, customerId, updateFeatureForTemplateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} featureId 
     * @param {string} templateId 
     * @param {UpdateFeatureForTemplateRequest} updateFeatureForTemplateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturesApi
     */
    public updateFeatureForTemplate(featureId: string, templateId: string, updateFeatureForTemplateRequest: UpdateFeatureForTemplateRequest, options?: RawAxiosRequestConfig) {
        return FeaturesApiFp(this.configuration).updateFeatureForTemplate(featureId, templateId, updateFeatureForTemplateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

